import { StateContext } from "../../../../../state/stateContext";
import { OVERVIEW_EVENTS } from "@ihs-widget/utils/enums";
import { useContext, useRef, useEffect, useState } from "react";
import { useLanguage } from "@ihs-widget/utils/hooks/useLanguage";
import { useTranslations } from "../../../../../translation/TranslationContext";

interface IGoalScorrerAndAssistProps {
    ml: string;
    mr: string;
    startPosition?: "start" | "end";
    event_type: string;
    player: string;
    label?: string | null;
    assistant?: string;
    isDescBold?: boolean;
    description?: string;
    containerWidth?: number;
}

export const EventNameAndPlayerName = ({ 
    ml,
    mr,
    startPosition = 'end',
    event_type,
    player,
    assistant,
    label,
    isDescBold = false,
    description,
    containerWidth
}: IGoalScorrerAndAssistProps) => {
    const eventRef = useRef<HTMLDivElement>(null);
    const ctx = useContext(StateContext);
    const { stContext, setStContext } = ctx || {};
    const { overviewEventAndTimeWidth } = stContext || {};
    
    const language = useLanguage();
    const t = useTranslations(language);

    const switchEventName = () => {
        switch (event_type) {
            case OVERVIEW_EVENTS.GOAL:
                return `${t[`InHouseStats.OverviewEventNameGoalAssist`]} ${assistant}`
            case OVERVIEW_EVENTS.PENALTY_SAVED:
                return t[`InHouseStats.OverviewEventNamePenaltySaved`]
            case OVERVIEW_EVENTS.YELLOW_CARD:
                return label ? t[label as keyof typeof t] : t[`InHouseStats.OverviewEventNameFoul`]
            case OVERVIEW_EVENTS.SECOND_YELLOW_CARD:
                return label ? t[label as keyof typeof t] : t[`InHouseStats.OverviewEventNameFoul`]
            case OVERVIEW_EVENTS.OWN_GOAL:
                return t[`InHouseStats.OverviewEventNameOwnGoal`]
            case OVERVIEW_EVENTS.RED_CARD:
                return label ? t[label as keyof typeof t] : t[`InHouseStats.OverviewEventNameFoul`]
            case OVERVIEW_EVENTS.OFFSIDE:
                return t[`InHouseStats.OverviewEventNameOffside`]
            case OVERVIEW_EVENTS.SHOT_ON_THE_TARGET:
                return t[`InHouseStats.ShotsOnTarget`]
            case OVERVIEW_EVENTS.SHOT_OFF_THE_TARGET:
                return t[`InHouseStats.ShotsOffTarget`]
            case OVERVIEW_EVENTS.CORNER:
                return t[`InHouseStats.OverviewEventNameCorner`]
            case OVERVIEW_EVENTS.PENALTY_SAVED:
                return t[`InHouseStats.OverviewEventNamePenaltySaved`]
            case OVERVIEW_EVENTS.PENALTY_MISSED:
                return t[`InHouseStats.OverviewEventNamePenaltyMissed`]
            case OVERVIEW_EVENTS.INJURY_BREAK:
                return t[`InHouseStats.OverviewEventNameInjuryBreak`]
            default:
                return `${player}`
        }
    }

    return (
        <div data-testid="event-name-and-player-name"
             ref={eventRef} className={`flex flex-col justify-center`} 
             style={{ 
                marginLeft: ml, 
                marginRight: mr, 
                alignItems: "flex-" + startPosition,
                maxWidth: containerWidth ? `${containerWidth-(overviewEventAndTimeWidth || 0)-8-((overviewEventAndTimeWidth || 0)-16)/2}px` : '230px'
            }}>
            <div data-testid="event-name-and-player-name-player" className={`text-base120 dark:text-monoY text-[12px] leading-[16px] font-robotoMedium w-full max-w-full 
                            whitespace-nowrap text-ellipsis overflow-x-hidden overflow-y-visible
                            [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] flex justify-${startPosition}`}>{player}</div>
            <div data-testid="event-name-and-player-name-event" className={`
                ${isDescBold ? "text-base120 dark:text-monoY" : "text-base0 dark:text-base090"}
                text-[12px] leading-[16px] 
                ${isDescBold ? "font-medium font-robotoMedium" : "font-normal font-robotoRegular"}
                whitespace-nowrap text-ellipsis overflow-x-hidden overflow-y-visible`}
                style={{
                    maxWidth: containerWidth ? `${containerWidth-(overviewEventAndTimeWidth || 0)-8-((overviewEventAndTimeWidth || 0)-16)/2}px` : '230px'
                }}
            >
                {switchEventName()}
            </div>
        </div>
    )
}